import React from 'react';
import TextField from '@material-ui/core/TextField';

export default function NumberField({ label, min, max, step, size, error, helperText, ...props }) {
  return (
    <TextField
      type="number"
      label={label}
      size={size}
      error={error}
      helperText={helperText}
      inputProps={{ min, max, step }}
      variant="outlined"
      margin="dense"
      fullWidth
      {...props}
    />
  );
}
